import React, { useState, useEffect } from "react";
import { Card, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { FiEdit, FiTrash2, FiPlus } from "react-icons/fi";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import {
  API_BREAK_LIST,
  API_BREAK_CREATE,
  API_BREAK_UPDATE,
  API_BREAK_DELETE,
} from "../../../service/url";
import { useAuth, errorCheck } from "../auth/auth-utils";
import { ROUTES } from "../../../utilities/constant";
import ToastNotification from "../../../components/Toast";
import exportData from "../../../utilities/export";
import Loader  from '../../../components/partials/components/loader';
import { toast } from 'react-toastify';
import {
  getUser,
} from "../../../utilities/setting";
import { USER_ROLES, MODULE_ACL } from "../../../utilities/constant";


const BreakList = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [searchValue, setSearchValue] = useState("");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [breakToDelete, setBreakToDelete] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newBreak, setNewBreak] = useState({
    title: "",
    duration: "",
    description: "",
    type: "Scheduled",
    status: true,
  });
  const [breaksData, setBreaksData] = useState([]);
  const [loggedInUserACL, setLoggedInUserACL] = useState({})
  const [isSuperAdmin, setIsSuperadmin] = useState(false)


  const handleStatusChange = (id, status) => {
    let newStatus;
    if (status == "1") {
      newStatus = "0";
    } else {
      newStatus = "1";
    }
    const url = API_BREAK_UPDATE.replace(":id", id);

    postApiCall(url, { status: newStatus })
      .then(onUpdateSuccess)
      .catch(onUpdateError);
  };

  const filteredBreaks = breaksData.filter((breakItem) =>
    breakItem.title.toLowerCase().includes(searchValue.toLowerCase())
  );

  useEffect(() => {
    setLoading(true);
    getApiCall(API_BREAK_LIST, {}).then(onListSuccess).catch(onError).finally(() => setLoading(false));
    getUser().then((user) => {
      if (user) {
        if (user.role === USER_ROLES.SUPERADMIN) {
          setIsSuperadmin(true);
        }

        if (user?.acl_settings) {
          setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
        }
      }
    });
  }, []);

  function onListSuccess(resp) {
    setBreaksData(resp);
  }

  function onError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
      toast.error(err);
    } else {
      console.log(err);
      toast.error(JSON.stringify(err));
    }
  }

  const handleCreateBreak = () => {
    // Validate title
    if (!newBreak.title.trim()) {
      toast.error("Break Title is required");
      return;
    }

    // Validate duration
    if (!newBreak.duration || newBreak.duration.toString().trim() === "") {
      toast.error("Break Duration is required");
      return;
    }

    const durationNum = Number(newBreak.duration);
    if (isNaN(durationNum)) {
      toast.error("Break Duration must be a valid number");
      return;
    }

    if (durationNum <= 0) {
      toast.error("Break Duration must be greater than 0");
      return;
    }

    if (durationNum > 1440) {
      toast.error("Break Duration must not exceed 1440 minutes (24 hours)");
      return;
    }

    if (!Number.isInteger(durationNum)) {
      toast.error("Break Duration must be a whole number (no decimals)");
      return;
    }

    const breakWithId = {
      title: newBreak.title,
      duration: durationNum.toString(), // Ensure it's a string as backend expects
      description: newBreak.description,
      type: newBreak.type,
      status: newBreak.status === true ? "1" : "0",
    };

    setShowCreateModal(false);
    setButtonDisable(true);

    postApiCall(API_BREAK_CREATE, breakWithId)
      .then((resp) => {
        onCreateSuccess(resp);
        resetForm();
        setButtonDisable(false);
      })
      .catch((err) => {
        onCreateError(err);
        setButtonDisable(false);
      });
  };

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  useEffect(() => {
    checkAuth(setToastProps, setShowToast);
  }, []);

  function onCreateSuccess(resp) {
    // setToastProps({
    //   message: "Breaks created successfully",
    //   type: "success",
    // });
    toast.success("Breaks created successfully");
    getApiCall(API_BREAK_LIST, {}).then(onListSuccess).catch(onError);
  }

  function onCreateError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      setButtonDisable(false);
      toast.error(JSON.stringify(err));
    }
  }

  function onUpdateSuccess(resp) {
    // setToastProps({
    //   message: "Breaks updated successfully",
    //   type: "success",
    // });
    toast.success("Breaks updated successfully");
    getApiCall(API_BREAK_LIST, {}).then(onListSuccess).catch(onError);
  }

  function onUpdateError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      setButtonDisable(false);
      toast.error(JSON.stringify(err));
    }
  }

  function onDeleteSuccess(resp) {
    // setToastProps({
    //   message: "Break deleted successfully",
    //   type: "success",
    // });
    toast.success("Breaks deleted successfully");
    getApiCall(API_BREAK_LIST, {}).then(onListSuccess).catch(onError);
  }

  function onDeleteError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      setButtonDisable(false);
      // setToastProps({ message: JSON.stringify(err), type: "danger" });
      toast.error(JSON.stringify(err));
    }
  }

  const resetForm = () => {
    setNewBreak({
      title: "",
      duration: "",
      description: "",
      type: "Scheduled",
      status: true,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewBreak((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const canEdit =
    isSuperAdmin || loggedInUserACL?.[MODULE_ACL.BREAKS]?.edit;

  const canDelete =
    isSuperAdmin || loggedInUserACL?.[MODULE_ACL.BREAKS]?.delete;


  const actionBodyTemplate = (rowData) => {
    if (!canEdit && !canDelete) return null; 

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          padding: "4px 8px",
          border: "1px solid #e0e0e0",
          borderRadius: "4px",
          width: "fit-content",
          margin: "0 auto",
        }}
      >
        {canEdit && (
          <FiEdit
            style={{ color: "#007bff", cursor: "pointer" }}
            onClick={() => handleAction("edit", rowData.id)}
          />
        )}

        {canEdit && canDelete && (
          <div
            style={{
              width: "1px",
              height: "16px",
              backgroundColor: "#e0e0e0",
            }}
          />
        )}

        {canDelete && (
          <FiTrash2
            style={{ color: "#dc3545", cursor: "pointer" }}
            onClick={() => handleAction("delete", rowData.id)}
          />
        )}
      </div>
    );
  };


  const handleAction = (action, id) => {
    if (action === "edit") {
      navigate(`/breaks/${id}`);
    } else if (action === "delete") {
      setBreakToDelete(id);
      setShowDeleteModal(true);
    }
  };

  const confirmDelete = () => {
    postApiCall(API_BREAK_DELETE, { id: breakToDelete })
      .then(onDeleteSuccess)
      .catch(onDeleteError);
    setShowDeleteModal(false);
    setBreakToDelete(null);
  };

  const typeBodyTemplate = (rowData) => <span>{rowData.type}</span>;

  const statusBodyTemplate = (rowData) => (
    <label className="inline-toggle">
      <input
        type="checkbox"
        checked={rowData.status == "1" ? true : false}
        onChange={() => handleStatusChange(rowData.id, rowData.status)}
      />
      <span className="slider" />
    </label>
  );

  const handleExport = async () => {
    setButtonDisable(true);
    await exportData("Breaks", setToastProps, setShowToast);
    setButtonDisable(false);
  };

  if (loading) {
          return <Loader />
       }

  return (
    <>
      <style>
        {`
          .inline-toggle {
            position: relative;
            display: inline-block;
            width: 50px;
            height: 26px;
          }

          .inline-toggle input {
            opacity: 0;
            width: 0;
            height: 0;
          }

          .inline-toggle .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #ccc;
            border-radius: 26px;
            transition: 0.3s;
          }

          .inline-toggle .slider:before {
            position: absolute;
            content: "";
            height: 20px;
            width: 20px;
            left: 3px;
            bottom: 3px;
            background-color: white;
            border-radius: 50%;
            transition: 0.3s;
          }

          .inline-toggle input:checked + .slider {
            background-color: #4caf50;
          }

          .inline-toggle input:checked + .slider:before {
            transform: translateX(24px);
          }
        `}
      </style>

      <div className="breaks-container">
        <Row>
          <Col sm="12">
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-0">
                <div className="header-title px-4 py-3 d-flex justify-content-between align-items-center">
                  <h4 className="card-title m-0">
                    Breaks ({breaksData.length})
                  </h4>
                  <div className="d-flex" style={{ gap: "8px" }}>
                    {breaksData.length > 0 && (
                      <Button
                        label="Export Data"
                        icon="pi pi-file-export"
                        onClick={handleExport}
                        className="p-button-active"
                        disabled={buttonDisable}
                      >
                        
                        &nbsp;
                        {buttonDisable && (
                          <span
                            className="spinner-border spinner-border-sm ml-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                        Export
                      </Button>
                    )}
                  {(isSuperAdmin || loggedInUserACL?.[MODULE_ACL.BREAKS]?.add) && (
                    <Button
                      variant="primary"
                      className="d-flex align-items-center"
                      onClick={() => setShowCreateModal(true)}
                    >
                      <FiPlus className="me-2" />
                      New Break
                    </Button>
                  )}
                  </div>
                </div>
                <div className="px-4 py-3 d-flex flex-wrap justify-content-between align-items-center">
                  <Form className="d-flex align-items-center">
                    <Form.Control
                      placeholder="Search Breaks..."
                      type="text"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      style={{ maxWidth: "250px" }}
                    />
                  </Form>
                </div>

                <div className="pb-4">
                  <div style={{ overflowX: "auto" }}>
                    <DataTable
                      value={filteredBreaks}
                      scrollable
                      scrollHeight="flex"
                      tableStyle={{ minWidth: "100%" }}
                      paginator
                      rows={5}
                      rowClassName="p-3"
                    >
                      <Column
                        field="title"
                        header="Name"
                        sortable
                        style={{ minWidth: "150px" }}
                      />
                      <Column
                        field="duration"
                        header="Duration"
                        sortable
                        style={{ minWidth: "120px" }}
                        body={(rowData) => (
                          <span>{rowData.duration} Minutes</span>
                        )}
                      />
                      <Column
                        field="description"
                        header="Description"
                        sortable
                        style={{ minWidth: "150px" }}
                      />
                      <Column
                        field="type"
                        header="Type"
                        body={typeBodyTemplate}
                        sortable
                        style={{ minWidth: "120px" }}
                      />
                      <Column
                        field="status"
                        header="Status"
                        body={statusBodyTemplate}
                        style={{ minWidth: "100px" }}
                      />
                      <Column
                        header="Action"
                        body={actionBodyTemplate}
                        style={{ width: "120px" }}
                      />
                    </DataTable>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Modal
          show={showCreateModal}
          onHide={() => {
            setShowCreateModal(false);
            resetForm();
          }}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Break</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>
                  Break Title <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={newBreak.title}
                  onChange={handleInputChange}
                  placeholder="Enter break title"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  Break Duration (In Minutes){" "}
                  <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="duration"
                  value={newBreak.duration}
                  onChange={handleInputChange}
                  placeholder="Enter duration in minutes"
                  min="0"
                  step="1"
                  onKeyDown={(e) => {
                  if (e.key === '-' || e.key === 'e') {
                  e.preventDefault();
                   } }}
                   onPaste={(e) => {
                   const pastedValue = e.clipboardData.getData('text');
                   if (Number(pastedValue) < 0) {
                   e.preventDefault();
                   } }}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Break Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="description"
                  value={newBreak.description}
                  onChange={handleInputChange}
                  placeholder="Enter description (optional)"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Break Type</Form.Label>
                <Form.Select
                  name="type"
                  value={newBreak.type}
                  onChange={handleInputChange}
                >
                  <option value="Scheduled">Scheduled</option>
                  <option value="Unscheduled">Unscheduled</option>
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowCreateModal(false);
                resetForm();
              }}
            >
              Discard Changes
            </Button>
            <Button
              variant="primary"
              onClick={handleCreateBreak}
              disabled={buttonDisable}
            >
              {buttonDisable ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Creating...
                </>
              ) : (
                "Create Break"
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete this break? This action cannot be
            undone.
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </Button>
            <Button variant="danger" onClick={confirmDelete}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      />
    </>
  );
};

export default BreakList;
